import React from "react";
import { Radio, RadioChangeEvent } from "antd";
import { useTranslation } from "react-i18next";

export const BooleanOptionRadioButton = (props: {
  value?: boolean | undefined;
  onChange?: (value: RadioChangeEvent) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Radio.Group
      name="verify"
      options={[
        { label: t("no"), value: false },
        { label: t("yes"), value: true },
      ]}
      optionType="button"
      buttonStyle="solid"
      {...props}
    />
  );
};
